module.exports = __webpack_public_path__ + "static/media/few-clouds-night.7e65840b.svg";